import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Builder from './pages/Builder';
import RenderView from './pages/RenderView';

function App() {
  return (
    <Router>
      <Routes>
        {/* The Service Interface */}
        <Route path="/" element={<Builder />} />
        
        {/* The Isolated Player Render (For Iframes) */}
        <Route path="/render" element={<RenderView />} />
      </Routes>
    </Router>
  );
}

export default App;